import { render, staticRenderFns } from "./nucleic-acid-report.vue?vue&type=template&id=aa87d5fc&scoped=true&"
import script from "./nucleic-acid-report.vue?vue&type=script&lang=js&"
export * from "./nucleic-acid-report.vue?vue&type=script&lang=js&"
import style0 from "./nucleic-acid-report.vue?vue&type=style&index=0&id=aa87d5fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa87d5fc",
  null
  
)

export default component.exports